var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tag-input/node_modules/core-js/library/modules/_cof.js
// module id = 304
// module chunks = 0